import React from 'react';
import { ProcessedInvoice, PaymentData } from '../../types';
import InvoiceCard from './InvoiceCard';
import { sortInvoicesByDueDate } from '../../utils/sorting';

interface InvoiceGridProps {
  invoices: ProcessedInvoice[];
  onDataChange: (id: string, data: PaymentData) => void;
}

export default function InvoiceGrid({ invoices, onDataChange }: InvoiceGridProps) {
  const sortedInvoices = sortInvoicesByDueDate(invoices);

  return (
    <div className="space-y-8">
      {/* Due Date Header */}
      {sortedInvoices.some(invoice => invoice.data.dueDate) && (
        <div className="text-sm text-[#86868b]">
          Sorted by due date (earliest first)
        </div>
      )}
      
      {/* Invoice Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 auto-rows-fr">
        {sortedInvoices.map((invoice) => (
          <div key={invoice.id} className="h-full">
            <InvoiceCard
              invoice={invoice}
              onDataChange={onDataChange}
            />
          </div>
        ))}
      </div>
    </div>
  );
}